module.exports = __webpack_public_path__ + "img/pinDesc.07df4dd7.png";